const useFindNoOfCheque = (SalesInvoices) => {
	const getPayments = 0;

	console.log(SalesInvoices, 'useFindNoOfCheque');

	// SalesInvoices?.forEach(({ payments }) => {
	// 	getPayments += payments.filter(({ payment_type }) => payment_type === 'Cheque').length;
	// });

	console.log(getPayments);

	return getPayments;
};

export default useFindNoOfCheque;
